export default __webpack_public_path__ + "static/glance-total-number-idp-dbced5de89dfba91ca9c2d17ff20d307.jpg";